import React from "react";

export default function Base({}) {
	return <>
		<path d="M0 100C5.88889 66.7778 5.88889 33.3333 0 0C16.6667 3 33.4444 4.44444 50 4.44444C66.5556 4.44444 83.3333 3 100 0C94.1111 33.2222 94.1111 66.6667 100 100C83.3333 97 66.5556 95.5556 50 95.5556C33.4444 95.5556 16.6667 97 0 100Z"/>
	</>
}